import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import TaskPopup, { TaskFormData, TaskPopupMode, Task as PopupTask } from './TaskPopup'
import WorkLogPopup, { WorkLogFormData, WorkLogPopupMode, WorkLog } from './WorkLogPopup'
import {
  GetTaskDetails,
  TaskDetailsResponse,
  SetTaskFilters,
  ClearTaskFilters,
  CreateTask,
  CreateWorkLog
} from './TaskAction'

// ── Global Styles (unchanged) ────────────────────────────────────────────────
const globalStyles = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&display=swap');

  @keyframes shimmer {
    0%   { background-position: -200% center; }
    100% { background-position:  200% center; }
  }
  @keyframes fadeSlideUp {
    from { opacity: 0; transform: translateY(12px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes cardIn {
    from { opacity:0; transform: translateY(16px) scale(.98); }
    to   { opacity:1; transform: translateY(0) scale(1); }
  }
  @keyframes rowIn {
    from { opacity:0; transform: translateX(-8px); }
    to   { opacity:1; transform: translateX(0); }
  }

  * { box-sizing: border-box; }

  .tm-page {
    font-family: 'DM Sans', sans-serif;
    min-height: 100vh;
    background: linear-gradient(145deg,#04111a 0%,#091e2e 35%,#0d2840 60%,#06141e 100%);
    position: relative;
    overflow-x: hidden;
    color: #e8f4f6;
  }
  .tm-grid-bg {
    position: fixed; inset: 0; pointer-events: none;
    background-image:
      linear-gradient(rgba(0,210,200,.022) 1px, transparent 1px),
      linear-gradient(90deg, rgba(0,210,200,.022) 1px, transparent 1px);
    background-size: 55px 55px;
    z-index: 0;
  }

  .tm-nav {
    position: sticky; top: 0; z-index: 20;
    background: linear-gradient(90deg, #041722 0%, #071f30 100%);
    border-bottom: 1px solid rgba(0,210,200,.15);
    backdrop-filter: blur(12px);
    display: flex;
    align-items: center;
    padding: 0 12px;
    height: 44px;
    gap: 2px;
    animation: fadeSlideUp .35s ease both;
    box-shadow: 0 2px 20px rgba(0,0,0,.5);
  }
  .tm-nav-logo {
    font-size: 13px;
    font-weight: 700;
    color: #00d2c8;
    letter-spacing: .06em;
    margin-right: 10px;
    padding-right: 12px;
    border-right: 1px solid rgba(0,210,200,.2);
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .tm-admin-badge {
    background: linear-gradient(135deg, #007a74, #005f6b);
    padding: 2px 10px;
    border-radius: 12px;
    font-size: 10px;
    font-weight: 700;
    color: white;
  }
  .tm-nav-item {
    padding: 6px 12px;
    font-size: 12px;
    font-weight: 600;
    color: #7ab0b8;
    border-radius: 6px;
    cursor: pointer;
    transition: all .18s;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 5px;
    letter-spacing: .02em;
  }
  .tm-nav-item:hover { color: #e8f4f6; background: rgba(0,210,200,.08); }
  .tm-nav-item.active {
    color: #00d2c8;
    background: rgba(0,210,200,.14);
    border: 1px solid rgba(0,210,200,.22);
  }

  .tm-breadcrumb {
    padding: 7px 16px;
    font-size: 12px;
    background: rgba(0,0,0,.2);
    border-bottom: 1px solid rgba(0,210,200,.08);
    display: flex;
    align-items: center;
    gap: 0;
    animation: fadeSlideUp .4s ease .05s both;
  }
  .tm-bc-link { color: #00d2c8; cursor: pointer; transition: color .2s; }
  .tm-bc-link:hover { color: #40e8e0; }
  .tm-bc-sep { margin: 0 6px; color: rgba(0,210,200,.35); }
  .tm-bc-cur { color: #7ab0b8; font-weight: 600; }

  .tm-content { position: relative; z-index: 1; padding: 10px 12px 24px; }

  .tm-filter-card {
    background: linear-gradient(160deg, rgba(12,28,45,.97) 0%, rgba(7,18,32,.99) 100%);
    border: 1px solid rgba(0,210,200,.16);
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 10px;
    box-shadow: 0 4px 24px rgba(0,0,0,.5), inset 0 1px 0 rgba(0,210,200,.07);
    animation: cardIn .45s cubic-bezier(.16,1,.3,1) .05s both;
  }
  .tm-shimmer {
    height: 2px;
    background: linear-gradient(90deg, transparent, #00d2c8, #48cae4, #00d2c8, transparent);
    background-size: 200% auto;
    animation: shimmer 3.5s linear infinite;
  }
  .tm-filter-header {
    background: linear-gradient(90deg, rgba(0,160,155,.26) 0%, rgba(0,120,175,.16) 100%);
    border-bottom: 1px solid rgba(0,210,200,.12);
    padding: 8px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }
  .tm-filter-title {
    font-size: 12px; font-weight: 700; color: #e8f4f6; letter-spacing: .04em;
  }
  .tm-filter-body {
    padding: 12px 16px;
    background: #c5d7d5;
  }
  .tm-filter-row {
    display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 8px; align-items: flex-end;
  }

  .tm-field { display: flex; flex-direction: column; min-width: 60px; }
  .tm-label {
    font-size: 10px; color: #1a5558; margin-bottom: 2px;
    white-space: nowrap; font-weight: 700; letter-spacing: .03em; text-transform: uppercase;
  }
  .tm-input-wrap { display: flex; align-items: center; gap: 4px; }
  .tm-input {
    width: 100%; padding: 4px 8px;
    border: 1px solid rgba(0,100,95,.28); border-radius: 6px;
    font-size: 11.5px; height: 26px; background: rgba(255,255,255,.5);
    color: #0b2d30; font-family: 'DM Sans', sans-serif; font-weight: 500;
    transition: border-color .2s, box-shadow .2s, background .2s;
    outline: none;
  }
  .tm-input:focus {
    border-color: #007a74; box-shadow: 0 0 0 3px rgba(0,120,115,.18);
    background: rgba(255,255,255,.72); color: #051c20;
  }
  select.tm-input { cursor: pointer; }
  select.tm-input option { background: #ddecea; color: #0b2d30; }
  .tm-input:disabled {
    background: rgba(200,200,200,0.3);
    border-color: rgba(0,100,95,.15);
    color: #2a7070;
    cursor: not-allowed;
  }

  .tm-btn {
    padding: 5px 13px;
    background: rgba(0,110,105,.15); border: 1px solid rgba(0,110,105,.3);
    border-radius: 20px; color: #094a47; font-size: 11.5px; font-weight: 600;
    cursor: pointer; transition: all .18s;
    display: inline-flex; align-items: center; gap: 4px; white-space: nowrap;
    height: 26px;
  }
  .tm-btn:hover { background: rgba(0,110,105,.26); box-shadow: 0 0 8px rgba(0,110,105,.2); }
  .tm-btn.primary {
    background: rgba(0,110,105,.25); border-color: rgba(0,110,105,.45);
    color: #003e3a;
  }
  .tm-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .tm-table-card {
    background: linear-gradient(160deg, rgba(12,28,45,.97) 0%, rgba(7,18,32,.99) 100%);
    border: 1px solid rgba(0,210,200,.16);
    border-radius: 12px; overflow: hidden;
    box-shadow: 0 4px 24px rgba(0,0,0,.5), inset 0 1px 0 rgba(0,210,200,.07);
    animation: cardIn .45s cubic-bezier(.16,1,.3,1) .1s both;
  }
  .tm-table-header {
    background: linear-gradient(90deg, rgba(0,160,155,.26) 0%, rgba(0,120,175,.16) 100%);
    border-bottom: 1px solid rgba(0,210,200,.12);
    padding: 9px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }
  .tm-table-title { font-size: 12px; font-weight: 700; color: #e8f4f6; letter-spacing: .04em; }
  .tm-table-meta  { font-size: 11px; color: #4a8890; font-weight: 600; }

  .tm-table-wrap {
    width: 100%;
    overflow-x: auto;
    background: #c5d7d5;
  }
  .tm-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 11.5px;
    min-width: 1600px;
  }
  .tm-table thead tr {
    background: linear-gradient(90deg, rgba(0,100,95,.28), rgba(0,80,130,.18));
    border-bottom: 2px solid rgba(0,140,130,.3);
  }
  .tm-table th {
    padding: 9px 10px;
    text-align: left;
    color: #1a5558;
    font-weight: 700;
    font-size: 10.5px;
    text-transform: uppercase;
    letter-spacing: .04em;
    white-space: nowrap;
  }

  .tm-group-row td {
    padding: 6px 10px;
    background: linear-gradient(90deg, rgba(0,100,95,.2), rgba(0,80,130,.1));
    border-top: 1px solid rgba(0,140,130,.2);
    border-bottom: 1px solid rgba(0,140,130,.15);
    font-size: 11px;
    font-weight: 700;
    color: #1a5558;
    cursor: pointer;
  }
  .tm-group-row:hover td { background: linear-gradient(90deg, rgba(0,100,95,.3), rgba(0,80,130,.18)); }

  .tm-table tbody tr.data-row {
    border-bottom: 1px solid rgba(0,110,105,.1);
    transition: background .13s;
    animation: rowIn .3s ease both;
  }
  .tm-table tbody tr.data-row:hover td { background: rgba(255,255,255,.18); }
  .tm-table td {
    padding: 8px 10px;
    color: #0b2d30;
    vertical-align: middle;
    white-space: nowrap;
  }

  .tm-cell-id    { color: #005e5a; font-weight: 700; font-size: 11px; }
  .tm-cell-task  { color: #092e30; font-weight: 600; }

  .tm-status {
    display: inline-flex; align-items: center; gap: 4px;
    padding: 3px 9px; border-radius: 12px; font-size: 10.5px; font-weight: 700;
    white-space: nowrap;
  }
  .tm-status-dot { width: 6px; height: 6px; border-radius: 50%; flex-shrink: 0; }
  .tm-status.open      { background: rgba(0,160,140,.16); border:1px solid rgba(0,160,140,.3); color:#004a46; }
  .tm-status.open .tm-status-dot { background:#00a08c; }
  .tm-status.progress  { background: rgba(180,120,0,.14); border:1px solid rgba(180,120,0,.28); color:#6a3c00; }
  .tm-status.progress .tm-status-dot { background:#c48000; }
  .tm-status.closed    { background: rgba(80,80,80,.14);  border:1px solid rgba(80,80,80,.28);  color:#444; }
  .tm-status.closed .tm-status-dot { background:#888; }
  .tm-status.hold      { background: rgba(180,40,40,.12); border:1px solid rgba(180,40,40,.26); color:#7a1010; }
  .tm-status.hold .tm-status-dot { background:#c03030; }
  .tm-status.completed { background: rgba(0,150,140,.16); border:1px solid rgba(0,150,140,.3); color:#004a46; }
  .tm-status.completed .tm-status-dot { background:#00968c; }

  .tm-employee-chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    background: rgba(0,100,95,.12);
    border: 1px solid rgba(0,100,95,.22);
    border-radius: 20px;
    font-size: 10.5px;
    font-weight: 600;
    color: #004a46;
  }

  .tm-blocker-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 12px;
    background: rgba(192,48,48,.12);
    border: 1px solid rgba(192,48,48,.25);
    color: #c03030;
    font-size: 12px;
    cursor: help;
  }

  .tm-worklog {
    font-weight: 700;
    color: #005e5a;
  }

  .tm-row-actions { display: flex; gap: 3px; }
  .tm-row-btn {
    width: 22px; height: 22px; border-radius: 5px;
    background: rgba(0,110,105,.12); border: 1px solid rgba(0,110,105,.22);
    color: #094a47; font-size: 11px;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; transition: all .15s;
  }
  .tm-row-btn:hover { background: rgba(0,110,105,.26); box-shadow: 0 0 8px rgba(0,110,105,.2); }

  .tm-pagination {
    display: flex; align-items: center; justify-content: space-between;
    padding: 10px 14px;
    background: rgba(0,50,45,.12);
    border-top: 1px solid rgba(0,110,105,.15);
    font-size: 11px; color: #2a7070; font-weight: 600;
  }
  .tm-page-btns { display: flex; gap: 3px; }
  .tm-page-btn {
    width: 26px; height: 26px; border-radius: 6px;
    background: rgba(0,110,105,.12); border: 1px solid rgba(0,110,105,.22);
    color: #094a47; font-size: 11px; font-weight: 700;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; transition: all .15s;
  }
  .tm-page-btn:hover { background: rgba(0,110,105,.25); }
  .tm-page-btn.active { background: rgba(0,110,105,.35); border-color: rgba(0,110,105,.55); color: #003e3a; }

  .tm-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px;
    color: #00d2c8;
    font-size: 14px;
  }

  .tm-error {
    background: rgba(192,48,48,0.2);
    border: 1px solid rgba(192,48,48,0.3);
    color: #ff8a8a;
    padding: 15px;
    border-radius: 8px;
    margin-bottom: 15px;
    text-align: center;
  }

  .tm-success-message {
    background: rgba(0,160,140,0.2);
    border: 1px solid rgba(0,160,140,0.3);
    color: #00d2c8;
    padding: 10px 15px;
    border-radius: 8px;
    margin-bottom: 15px;
    text-align: center;
    font-weight: 600;
  }
`

// ── Data ─────────────────────────────────────────────────────────────────────

const projects = ['All', 'HRMS Phase 1', 'ERP Migration', 'Client Portal', 'Data Warehouse', 'Mobile App']
const delivUnits = ['All', 'Backend', 'Frontend', 'QA', 'DevOps', 'Design', 'Database']
const statusOpts = ['All', 'Open', 'In Progress', 'On Hold', 'Closed', 'Completed']

// Employee interface
export interface Employee {
  ID: number
  EmployeeID: number
  EmployeeCode: string
  EmployeeName: string
  Email: string
  MobileNumber: string
  Department: string
  Designation: string
  EmploymentStatus: string
  IsActive: boolean
  firstName?: string
  lastName?: string
}

// Task interface (matches what the popup expects and what TaskAction returns)
export interface Task {
  taskId: string
  mainTaskId: string
  taskName: string
  taskDescription: string
  taskTaken: string
  taskGivenTo: string
  taskGivenBy: string
  status: 'Open' | 'In Progress' | 'On Hold' | 'Closed' | 'Completed'
  anyBlocker: string
  worklogHour: number
  startDate: string
  endDate: string
  task: string
  phone?: string
  deliveryUnit?: string
  priority?: 'high' | 'medium' | 'low'
  initials?: string
  openWU?: number
  logNo?: string
  estimatedHours?: number
  actualHours?: number
  tags?: string[]
  taskGivenToName?: string
  taskGivenByName?: string
  progressPercentage?: number
  isOverdue?: boolean
  daysRemaining?: number
  totalLoggedHours?: number
  workLogCount?: number
  totalCall?: number
}

// ── Helper Functions ─────────────────────────────────────────────────────────

function dueClass(dateStr: string, status: string) {
  if (!dateStr || status === 'Closed' || status === 'Completed') return 'ok'
  const diff = (new Date(dateStr).getTime() - Date.now()) / 86400000
  if (diff < 0) return 'overdue'
  if (diff < 7) return 'soon'
  return 'ok'
}

function fmtDate(s: string | number) {
  if (!s) return '—'
  if (typeof s === 'number') {
    return new Date(s).toLocaleDateString('en-GB')
  }
  return new Date(s).toLocaleDateString('en-GB')
}

function statusCls(s: string) {
  if (s === 'Open') return 'open'
  if (s === 'In Progress') return 'progress'
  if (s === 'On Hold') return 'hold'
  if (s === 'Completed') return 'completed'
  return 'closed'
}

function getEmployeeName(empCode: string, empName?: string, employees: Employee[] = []): string {
  if (empName) return empName
  const emp = employees.find(e => e.EmployeeCode === empCode)
  return emp ? `${emp.EmployeeName} (${emp.EmployeeCode})` : empCode
}

function getMainTaskId(taskId: string | undefined): string {
  if (!taskId || typeof taskId !== 'string') {
    return 'MT-000';
  }
  const match = taskId.match(/\d+/);
  if (match) {
    const num = parseInt(match[0]);
    const mainNum = Math.floor(num / 1000) * 1000;
    return `MT-${String(mainNum).padStart(3, '0')}`;
  }
  return 'MT-000';
}

function Field({ label, width = 'auto', children }: { label: string; width?: string; children: React.ReactNode }) {
  return (
    <div className="tm-field" style={{ width }}>
      <div className="tm-label">{label}</div>
      <div className="tm-input-wrap">{children}</div>
    </div>
  )
}

function groupByMainTask(tasks: Task[]) {
  const map: Record<string, Task[]> = {}
  for (const t of tasks) {
    if (!map[t.mainTaskId]) map[t.mainTaskId] = []
    map[t.mainTaskId].push(t)
  }
  return map
}

interface StateProps {
  tasks: Task[]   // Already converted tasks from Redux
  employees: Employee[]
  loading: boolean
  error: any
  filters: any
}

interface DispatchProps {
  getTaskDetails: (employeeCode?: string) => void
  setTaskFilters: (filters: { EmployeeCode?: string }) => void
  clearTaskFilters: () => void
  createTask: (taskData: any) => Promise<any>
  createWorkLog: (workLogData: any) => Promise<any>
}

type Props = StateProps & DispatchProps

interface TMState {
  search: string
  statusFilter: string
  collapsed: Record<string, boolean>
  page: number
  isTaskPopupOpen: boolean
  isWorkLogPopupOpen: boolean
  taskPopupMode: TaskPopupMode
  workLogPopupMode: WorkLogPopupMode
  selectedTask: Task | null
  selectedWorkLog: WorkLog | null
  localTasks: Task[]
  employeeCodeFilter: string
  employees: Employee[]
  loggedInEmployeeCode: string | null
  isSubmitting: boolean
  isWorkLogSubmitting: boolean
  submitError: string | null
  workLogSubmitError: string | null
  successMessage: string | null
  workLogSuccessMessage: string | null
  roleCode: string | null
  isAdmin: boolean
}

class TaskManagementPage extends PureComponent<Props, TMState> {
  constructor(props: Props) {
    super(props)
    const roleCode = sessionStorage.getItem('RoleCode');
    const isAdmin = roleCode === 'ADMIN';

    this.state = {
      search: '',
      statusFilter: 'All',
      collapsed: {},
      page: 1,
      isTaskPopupOpen: false,
      isWorkLogPopupOpen: false,
      taskPopupMode: 'create',
      workLogPopupMode: 'create',
      selectedTask: null,
      selectedWorkLog: null,
      localTasks: props.tasks || [],   // Initialize with props
      employeeCodeFilter: '',
      employees: props.employees || [],
      loggedInEmployeeCode: null,
      isSubmitting: false,
      isWorkLogSubmitting: false,
      submitError: null,
      workLogSubmitError: null,
      successMessage: null,
      workLogSuccessMessage: null,
      roleCode: roleCode,
      isAdmin: isAdmin
    }
  }

  componentDidMount() {
    const employeeCode = sessionStorage.getItem("employeeCode")
    const { isAdmin } = this.state

    this.setState({
      loggedInEmployeeCode: employeeCode,
      employeeCodeFilter: isAdmin ? '' : (employeeCode || '')
    })

    console.log("Logged in employee code:", employeeCode)
    console.log("Is Admin:", isAdmin)

    if (isAdmin) {
      this.props.getTaskDetails(undefined)
    } else {
      this.props.getTaskDetails(employeeCode || undefined)
      if (employeeCode) {
        this.props.setTaskFilters({ EmployeeCode: employeeCode })
      }
    }
  }

  componentDidUpdate(prevProps: Props) {
    // Tasks from Redux are already converted – use them directly
    if (prevProps.tasks !== this.props.tasks) {
      this.setState({ localTasks: this.props.tasks || [] });
    }

    if (prevProps.employees !== this.props.employees) {
      this.setState({ employees: this.props.employees || [] });
    }

    if (prevProps.filters !== this.props.filters && this.props.filters?.EmployeeCode) {
      this.setState({ employeeCodeFilter: this.props.filters.EmployeeCode });
    }
  }

  // Handle employee selection from dropdown - triggers API call
  handleEmployeeCodeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedCode = e.target.value
    const { isAdmin, loggedInEmployeeCode } = this.state

    console.log("Employee selected:", selectedCode)

    this.setState({ employeeCodeFilter: selectedCode }, () => {
      if (!isAdmin && selectedCode !== loggedInEmployeeCode && selectedCode !== '') {
        console.log("Non-admin cannot filter by other employees")
        return
      }

      const codeToSend = selectedCode && selectedCode.trim() !== '' ? selectedCode : undefined
      this.props.getTaskDetails(codeToSend)
      this.props.setTaskFilters({ EmployeeCode: codeToSend || '' })
      this.setState({ page: 1 })
    })
  }

  handleFilterByEmployee = () => {
    const { employeeCodeFilter, isAdmin, loggedInEmployeeCode } = this.state

    if (!isAdmin && employeeCodeFilter !== loggedInEmployeeCode && employeeCodeFilter !== '') {
      console.log("Non-admin cannot filter by other employees")
      return
    }

    const codeToSend = employeeCodeFilter && employeeCodeFilter.trim() !== ''
      ? employeeCodeFilter
      : undefined;

    this.props.setTaskFilters({ EmployeeCode: codeToSend || '' })
    this.props.getTaskDetails(codeToSend)
    this.setState({ page: 1 })
  }

  handleFilterByLoggedInEmployee = () => {
    const { loggedInEmployeeCode, isAdmin } = this.state

    if (loggedInEmployeeCode) {
      console.log("Filtering by logged-in employee code:", loggedInEmployeeCode)

      this.setState({ employeeCodeFilter: loggedInEmployeeCode }, () => {
        this.props.setTaskFilters({ EmployeeCode: loggedInEmployeeCode })
        this.props.getTaskDetails(loggedInEmployeeCode)
        this.setState({ page: 1 })
      })
    }
  }

  handleResetFilters = () => {
    const { isAdmin, loggedInEmployeeCode } = this.state

    this.setState({
      search: '',
      statusFilter: 'All',
      employeeCodeFilter: isAdmin ? '' : (loggedInEmployeeCode || '')
    }, () => {
      this.props.clearTaskFilters()

      if (isAdmin) {
        this.props.getTaskDetails(undefined)
      } else {
        this.props.getTaskDetails(loggedInEmployeeCode || undefined)
      }
      this.setState({ page: 1 })
    })
  }

  handleRefresh = () => {
    const { employeeCodeFilter, isAdmin, loggedInEmployeeCode } = this.state

    let codeToSend: string | undefined;

    if (isAdmin) {
      codeToSend = employeeCodeFilter && employeeCodeFilter.trim() !== ''
        ? employeeCodeFilter
        : undefined;
    } else {
      codeToSend = loggedInEmployeeCode || undefined;
    }

    this.props.getTaskDetails(codeToSend)
  }

  toggleGroup = (id: string) => {
    this.setState(prev => ({
      collapsed: { ...prev.collapsed, [id]: !prev.collapsed[id] }
    }))
  }

  handleOpenCreateTask = () => {
    this.setState({
      isTaskPopupOpen: true,
      taskPopupMode: 'create',
      selectedTask: null,
      submitError: null,
      successMessage: null
    })
  }

  handleOpenEditTask = (task: Task) => {
    this.setState({
      isTaskPopupOpen: true,
      taskPopupMode: 'edit',
      selectedTask: task,
      submitError: null,
      successMessage: null
    })
  }

  handleOpenCreateWorkLog = (task: Task) => {
    this.setState({
      isWorkLogPopupOpen: true,
      workLogPopupMode: 'create',
      selectedTask: task,
      selectedWorkLog: null,
      workLogSubmitError: null,
      workLogSuccessMessage: null
    })
  }

  handleOpenEditWorkLog = (workLog: WorkLog) => {
    this.setState({
      isWorkLogPopupOpen: true,
      workLogPopupMode: 'edit',
      selectedWorkLog: workLog,
      workLogSubmitError: null,
      workLogSuccessMessage: null
    })
  }

  handleOpenViewWorkLog = (workLog: WorkLog) => {
    this.setState({
      isWorkLogPopupOpen: true,
      workLogPopupMode: 'view',
      selectedWorkLog: workLog,
      workLogSubmitError: null,
      workLogSuccessMessage: null
    })
  }

  handleOpenViewTaskWorkLogs = (task: Task) => {
    this.setState({
      isWorkLogPopupOpen: true,
      workLogPopupMode: 'view',
      selectedTask: task,
      selectedWorkLog: null,
      workLogSubmitError: null,
      workLogSuccessMessage: null
    })
  }

  handleCloseTaskPopup = () => {
    this.setState({
      isTaskPopupOpen: false,
      isSubmitting: false,
      submitError: null
    })
  }

  handleCloseWorkLogPopup = () => {
    this.setState({
      isWorkLogPopupOpen: false,
      isWorkLogSubmitting: false,
      workLogSubmitError: null,
      workLogSuccessMessage: null,
      selectedWorkLog: null
    })
  }

 handleSaveTask = async (taskData: TaskFormData) => {
    const { taskPopupMode, selectedTask, loggedInEmployeeCode, employeeCodeFilter } = this.state
    const { createTask, getTaskDetails } = this.props

    if (taskPopupMode === 'create') {
      this.setState({ isSubmitting: true, submitError: null, successMessage: null })

      try {
        // Prepare work_logs array
        let workLogs: any = [];
        if (taskData.worklogHour && taskData.worklogHour > 0) {
          workLogs = [{
            work_date: new Date().toISOString().split('T')[0],
            hours_logged: taskData.worklogHour,
            description: taskData.taskName,
            employee_code: taskData.taskGivenTo || loggedInEmployeeCode
          }];
        }

        // Prepare comments array
        let comments: any = [];
        if (taskData.taskTaken && loggedInEmployeeCode) {
          comments = [{
            comment: taskData.taskTaken,
            employee_code: loggedInEmployeeCode
          }];
        }

        const apiTaskData = {
          action: "I",
          taskId: "",  // Empty string for new task (backend will generate)
          taskName: taskData.taskName,
          taskDescription: taskData.taskDescription,
          taskTaken: taskData.taskTaken,
          taskGivenTo: taskData.taskGivenTo || loggedInEmployeeCode,
          taskGivenBy: taskData.taskGivenBy || loggedInEmployeeCode,
          status: taskData.status,
          anyBlocker: taskData.anyBlocker || "",
          worklogHour: taskData.worklogHour || 0,
          startDate: taskData.startDate || null,
          endDate: taskData.endDate || null,
          phone: taskData.phone || "",
          deliveryUnit: taskData.deliveryUnit || "Backend",
          priority: taskData.priority || "medium",
          openWu: taskData.openWU || 0,
          logNo: taskData.logNo || `LG-${String(Math.floor(Math.random() * 900) + 100)}`,
          estimatedHours: taskData.estimatedHours || 0,
          actualHours: 0,
          work_logs: workLogs,
          comments: comments,
          changedBy: loggedInEmployeeCode,
          totalCall: taskData.totalCall || 0
        }

        console.log("Creating task with data:", apiTaskData)

        const result = await createTask(apiTaskData)

        if (result && result.success) {
          this.setState({
            successMessage: `✅ Task created successfully! Task ID: ${result.taskId}`,
            isSubmitting: false
          })

          const codeToSend = employeeCodeFilter && employeeCodeFilter.trim() !== ''
            ? employeeCodeFilter
            : undefined;

          await getTaskDetails(codeToSend)

          setTimeout(() => {
            this.handleCloseTaskPopup()
            this.setState({ successMessage: null })
          }, 2000)
        } else {
          this.setState({
            submitError: result?.message || '❌ Failed to create task. Please try again.',
            isSubmitting: false
          })
        }
      } catch (error) {
        console.error("Error creating task:", error)
        this.setState({
          submitError: error instanceof Error ? error.message : '❌ An error occurred while creating the task',
          isSubmitting: false
        })
      }

    } else if (taskPopupMode === 'edit' && selectedTask) {
      this.setState({ isSubmitting: true, submitError: null, successMessage: null })

      try {
        // IMPORTANT: Use the values from the popup form (taskData) not from selectedTask
        // The user might have changed the assignee in the dropdown
        const apiTaskData = {
          action: "U",
          taskId: selectedTask.taskId,
          taskName: taskData.taskName,
          taskDescription: taskData.taskDescription || taskData.taskTaken,
          taskTaken: taskData.taskTaken,
          taskGivenTo: taskData.taskGivenTo,  // Use the value from the form (user selection)
          taskGivenBy: taskData.taskGivenBy,  // Use the value from the form (user selection)
          status: taskData.status,
          anyBlocker: taskData.anyBlocker || "",
          worklogHour: taskData.worklogHour || 0,
          startDate: taskData.startDate || null,
          endDate: taskData.endDate || null,
          phone: taskData.phone || "",
          deliveryUnit: taskData.deliveryUnit || "Backend",
          priority: taskData.priority || "medium",
          openWu: taskData.openWU || 0,
          logNo: taskData.logNo || selectedTask.logNo,
          estimatedHours: taskData.estimatedHours || 0,
          actualHours: taskData.actualHours || 0,
          work_logs: [],
          comments: [],
          changedBy: loggedInEmployeeCode,
          totalCall: taskData.totalCall || 0
        }

        console.log("Updating task with data:", apiTaskData)

        const result = await createTask(apiTaskData)

        if (result && result.success) {
          this.setState({
            successMessage: `✅ Task updated successfully! Task ID: ${selectedTask.taskId}`,
            isSubmitting: false
          })

          const codeToSend = employeeCodeFilter && employeeCodeFilter.trim() !== ''
            ? employeeCodeFilter
            : undefined;

          await getTaskDetails(codeToSend)

          setTimeout(() => {
            this.handleCloseTaskPopup()
            this.setState({ successMessage: null })
          }, 2000)
        } else {
          this.setState({
            submitError: result?.message || '❌ Failed to update task.',
            isSubmitting: false
          })
        }
      } catch (error) {
        console.error("Error updating task:", error)
        this.setState({
          submitError: error instanceof Error ? error.message : '❌ An error occurred while updating the task',
          isSubmitting: false
        })
      }
    }
  }
  handleDeleteTask = async () => {
    const { selectedTask, employeeCodeFilter } = this.state
    const { createTask, getTaskDetails } = this.props

    if (selectedTask && window.confirm(`Are you sure you want to delete task ${selectedTask.taskId}?`)) {
      this.setState({ isSubmitting: true, submitError: null, successMessage: null })

      try {
        const apiTaskData = {
          action: "D",
          taskId: selectedTask.taskId,
          changedBy: this.state.loggedInEmployeeCode,
          work_logs: [],
          comments: []
        }

        console.log("Deleting task with data:", apiTaskData)

        const result = await createTask(apiTaskData)

        if (result && result.success) {
          this.setState({
            successMessage: `✅ Task deleted successfully: ${selectedTask.taskId}`,
            isSubmitting: false
          })

          const codeToSend = employeeCodeFilter && employeeCodeFilter.trim() !== ''
            ? employeeCodeFilter
            : undefined;

          await getTaskDetails(codeToSend)

          setTimeout(() => {
            this.handleCloseTaskPopup()
            this.setState({ successMessage: null })
          }, 2000)
        } else {
          this.setState({
            submitError: result?.message || '❌ Failed to delete task.',
            isSubmitting: false
          })
        }
      } catch (error) {
        console.error("Error deleting task:", error)
        this.setState({
          submitError: error instanceof Error ? error.message : '❌ An error occurred while deleting the task',
          isSubmitting: false
        })
      }
    }
  }

  handleSaveWorkLog = async (workLogData: WorkLogFormData) => {
    const { workLogPopupMode, selectedWorkLog, selectedTask, loggedInEmployeeCode, employeeCodeFilter } = this.state
    const { createWorkLog, getTaskDetails } = this.props

    if (workLogPopupMode === 'create') {
      this.setState({ isWorkLogSubmitting: true, workLogSubmitError: null, workLogSuccessMessage: null })

      try {
        const apiWorkLogData = {
          log_id: workLogData.logId,
          log_no: workLogData.logNo || null,
          task_id: workLogData.taskId || selectedTask?.taskId,
          employee_code: workLogData.employeeCode || loggedInEmployeeCode,
          work_date: workLogData.workDate,
          hours_logged: workLogData.hoursLogged,
          description: workLogData.description || '',
          total_call: workLogData.totalCall || 0
        }

        console.log("Creating work log with data:", apiWorkLogData)

        const result = await createWorkLog(apiWorkLogData)

        if (result && result.success) {
          this.setState({
            workLogSuccessMessage: `✅ Work log created successfully! Log ID: ${result.log_id}`,
            isWorkLogSubmitting: false
          })

          const codeToSend = employeeCodeFilter && employeeCodeFilter.trim() !== ''
            ? employeeCodeFilter
            : undefined;

          await getTaskDetails(codeToSend)

          setTimeout(() => {
            this.handleCloseWorkLogPopup()
            this.setState({ workLogSuccessMessage: null })
          }, 2000)
        } else {
          this.setState({
            workLogSubmitError: result?.message || '❌ Failed to create work log. Please try again.',
            isWorkLogSubmitting: false
          })
        }
      } catch (error) {
        console.error("Error creating work log:", error)
        this.setState({
          workLogSubmitError: error instanceof Error ? error.message : '❌ An error occurred while creating the work log',
          isWorkLogSubmitting: false
        })
      }
    } else if (workLogPopupMode === 'edit' && selectedWorkLog) {
      this.setState({ isWorkLogSubmitting: true, workLogSubmitError: null, workLogSuccessMessage: null })

      try {
        await new Promise(resolve => setTimeout(resolve, 1000))

        this.setState({
          workLogSuccessMessage: `✅ Work log updated successfully!`,
          isWorkLogSubmitting: false
        })

        setTimeout(() => {
          this.handleCloseWorkLogPopup()
          this.setState({ workLogSuccessMessage: null })
        }, 2000)
      } catch (error) {
        console.error("Error updating work log:", error)
        this.setState({
          workLogSubmitError: error instanceof Error ? error.message : '❌ An error occurred',
          isWorkLogSubmitting: false
        })
      }
    }
  }

  handleDeleteWorkLog = async () => {
    const { selectedWorkLog } = this.state

    if (selectedWorkLog && window.confirm(`Are you sure you want to delete this work log?`)) {
      this.setState({ isWorkLogSubmitting: true, workLogSubmitError: null, workLogSuccessMessage: null })

      try {
        await new Promise(resolve => setTimeout(resolve, 1000))

        this.setState({
          workLogSuccessMessage: `✅ Work log deleted successfully`,
          isWorkLogSubmitting: false
        })

        setTimeout(() => {
          this.handleCloseWorkLogPopup()
          this.setState({ workLogSuccessMessage: null })
        }, 1500)
      } catch (error) {
        console.error("Error deleting work log:", error)
        this.setState({
          workLogSubmitError: error instanceof Error ? error.message : '❌ An error occurred',
          isWorkLogSubmitting: false
        })
      }
    }
  }

  render() {
    const { loading, error } = this.props
    const {
      search,
      statusFilter,
      collapsed,
      localTasks,
      isTaskPopupOpen,
      isWorkLogPopupOpen,
      taskPopupMode,
      workLogPopupMode,
      selectedTask,
      selectedWorkLog,
      employeeCodeFilter,
      employees,
      loggedInEmployeeCode,
      isSubmitting,
      isWorkLogSubmitting,
      submitError,
      workLogSubmitError,
      successMessage,
      workLogSuccessMessage,
      isAdmin,
      roleCode
    } = this.state

    const filtered = (localTasks || []).filter(t =>
      t &&
      (statusFilter === 'All' || t.status === statusFilter) &&
      (search === '' ||
        (t.taskName && t.taskName.toLowerCase().includes(search.toLowerCase())) ||
        (t.taskId && t.taskId.toLowerCase().includes(search.toLowerCase())) ||
        (t.taskTaken && t.taskTaken.toLowerCase().includes(search.toLowerCase())))
    )

    const groups = groupByMainTask(filtered)
    const mainTaskIds = Object.keys(groups)

    const stats = {
      total: filtered.length,
      open: filtered.filter(t => t.status === 'Open').length,
      progress: filtered.filter(t => t.status === 'In Progress').length,
      hold: filtered.filter(t => t.status === 'On Hold').length,
      closed: filtered.filter(t => t.status === 'Closed' || t.status === 'Completed').length,
      overdue: filtered.filter(t => t.isOverdue).length
    }

    return (
      <>
        <style>{globalStyles}</style>
        <div className="tm-page">
          <div className="tm-grid-bg" />

          <div className="tm-nav">
            <div className="tm-nav-logo">
              TASK MANAGER
              {isAdmin && <span className="tm-admin-badge">ADMIN</span>}
            </div>
          </div>

          <div className="tm-breadcrumb">
            <span className="tm-bc-link">Dashboard</span>
            <span className="tm-bc-sep">/</span>
            <span className="tm-bc-cur">Task Management</span>
            {loggedInEmployeeCode && (
              <>
                <span className="tm-bc-sep">/</span>
                <span className="tm-bc-cur">Logged in: {loggedInEmployeeCode}</span>
              </>
            )}
            {isAdmin && employeeCodeFilter && employeeCodeFilter !== '' && (
              <>
                <span className="tm-bc-sep">/</span>
                <span className="tm-bc-cur">Filter: {employeeCodeFilter}</span>
              </>
            )}
            {!isAdmin && (
              <>
                <span className="tm-bc-sep">/</span>
                <span className="tm-bc-cur">My Tasks Only</span>
              </>
            )}
          </div>

          <div className="tm-content">
            {successMessage && (
              <div className="tm-success-message">
                {successMessage}
              </div>
            )}

            <div style={{ display: 'flex', gap: 8, marginBottom: 10, flexWrap: 'wrap' }}>
              <div style={{
                background: 'rgba(0,160,140,0.15)',
                border: '1px solid rgba(0,160,140,0.25)',
                borderRadius: '20px',
                padding: '6px 15px',
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                color: '#00d2c8'
              }}>
                <span>📋 Total: {stats.total}</span>
              </div>
              <div style={{
                background: 'rgba(0,160,140,0.15)',
                border: '1px solid rgba(0,160,140,0.25)',
                borderRadius: '20px',
                padding: '6px 15px',
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                color: '#00a08c'
              }}>
                <span>🟢 Open: {stats.open}</span>
              </div>
              <div style={{
                background: 'rgba(196,128,0,0.15)',
                border: '1px solid rgba(196,128,0,0.25)',
                borderRadius: '20px',
                padding: '6px 15px',
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                color: '#c48000'
              }}>
                <span>🟡 In Progress: {stats.progress}</span>
              </div>
              <div style={{
                background: 'rgba(192,48,48,0.15)',
                border: '1px solid rgba(192,48,48,0.25)',
                borderRadius: '20px',
                padding: '6px 15px',
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                color: '#c03030'
              }}>
                <span>🔴 On Hold: {stats.hold}</span>
              </div>
              <div style={{
                background: 'rgba(0,150,140,0.15)',
                border: '1px solid rgba(0,150,140,0.25)',
                borderRadius: '20px',
                padding: '6px 15px',
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                color: '#00968c'
              }}>
                <span>✅ Completed: {stats.closed}</span>
              </div>
              <div style={{
                background: 'rgba(255,100,100,0.15)',
                border: '1px solid rgba(255,100,100,0.25)',
                borderRadius: '20px',
                padding: '6px 15px',
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                color: '#ff6464'
              }}>
                <span>⚠️ Overdue: {stats.overdue}</span>
              </div>
            </div>

            <div className="tm-filter-card">
              <div className="tm-shimmer" />
              <div className="tm-filter-header">
                <span className="tm-filter-title">🔍 Filter & Search</span>
                <div style={{ display: 'flex', gap: 6 }}>
                  <span className="tm-btn primary" onClick={this.handleFilterByLoggedInEmployee}>
                    👤 My Tasks
                  </span>
                  <span className="tm-btn primary" onClick={this.handleRefresh}>
                    🔄 Refresh
                  </span>
                  {isAdmin && (
                    <span className="tm-btn primary" onClick={this.handleFilterByEmployee}>
                      🔍 Apply Filter
                    </span>
                  )}
                  <span className="tm-btn" onClick={this.handleResetFilters}>
                    ↻ Reset
                  </span>
                </div>
              </div>
              <div className="tm-filter-body">
                <div className="tm-filter-row">
                  {isAdmin ? (
                    <Field label="Employee" width="250px">
                      <select
                        className="tm-input"
                        value={employeeCodeFilter}
                        onChange={this.handleEmployeeCodeChange}
                        style={{ width: '100%', cursor: 'pointer' }}
                      >
                        <option value="">-- All Employees --</option>
                        {employees && employees.length > 0 ? (
                          employees
                            .filter(emp => emp.IsActive !== false)
                            .map(emp => (
                              <option key={emp.EmployeeCode} value={emp.EmployeeCode}>
                                {emp.EmployeeName} ({emp.EmployeeCode}) - {emp.Designation}
                              </option>
                            ))
                        ) : (
                          <option value="" disabled>Loading employees...</option>
                        )}
                      </select>
                    </Field>
                  ) : (
                    <Field label="Employee" width="250px">
                      <input
                        type="text"
                        className="tm-input"
                        value={loggedInEmployeeCode ? `${loggedInEmployeeCode} (My Tasks Only)` : 'Loading...'}
                        disabled
                        style={{ background: 'rgba(200,200,200,0.3)' }}
                      />
                    </Field>
                  )}

                  <Field label="Status" width="120px">
                    <select
                      className="tm-input"
                      value={statusFilter}
                      onChange={(e) => this.setState({ statusFilter: e.target.value })}
                    >
                      {statusOpts.map(o => <option key={o}>{o}</option>)}
                    </select>
                  </Field>
                  <Field label="From Date" width="120px">
                    <input type="date" className="tm-input" />
                  </Field>
                  <Field label="To Date" width="120px">
                    <input type="date" className="tm-input" />
                  </Field>
                  <Field label="Search" width="200px">
                    <input
                      type="text"
                      className="tm-input"
                      placeholder="Task ID, name or description..."
                      value={search}
                      onChange={(e) => this.setState({ search: e.target.value })}
                    />
                  </Field>
                </div>
                <div style={{ marginTop: 8, fontSize: 10, color: '#1a5558', display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                  {loggedInEmployeeCode && (
                    <span style={{ background: 'rgba(0,160,140,0.1)', padding: '2px 8px', borderRadius: 12 }}>
                      👤 Logged in: <strong>{loggedInEmployeeCode}</strong>
                    </span>
                  )}
                  <span style={{ background: 'rgba(0,160,140,0.1)', padding: '2px 8px', borderRadius: 12 }}>
                    👥 {employees.length} employees loaded
                  </span>
                  {isAdmin && employeeCodeFilter && employeeCodeFilter !== '' && (
                    <span style={{ background: 'rgba(0,160,140,0.1)', padding: '2px 8px', borderRadius: 12 }}>
                      🔍 Filtering by: <strong>{employeeCodeFilter}</strong>
                    </span>
                  )}
                  {!isAdmin && (
                    <span style={{ background: 'rgba(0,160,140,0.1)', padding: '2px 8px', borderRadius: 12 }}>
                      🔒 Viewing only your assigned tasks
                    </span>
                  )}
                  {roleCode && (
                    <span style={{ background: 'rgba(0,160,140,0.1)', padding: '2px 8px', borderRadius: 12 }}>
                      🎭 Role: <strong>{roleCode}</strong>
                    </span>
                  )}
                </div>
              </div>
            </div>

            {loading && (
              <div className="tm-loading">
                <span>Loading tasks...</span>
              </div>
            )}

            {error && (
              <div className="tm-error">
                <span>⚠️ {error.message || 'Failed to fetch tasks'}</span>
              </div>
            )}

            {!loading && !error && (
              <div className="tm-table-card">
                <div className="tm-shimmer" />
                <div className="tm-table-header">
                  <span className="tm-table-title">📋 Task List</span>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <span className="tm-table-meta">{filtered.length} tasks across {mainTaskIds.length} main tasks</span>
                    <span
                      className="tm-btn"
                      onClick={this.handleOpenCreateTask}
                      style={{ cursor: 'pointer', color: "white" }}
                    >
                      ➕ &nbsp;New Task
                    </span>
                  </div>
                </div>

                <div className="tm-table-wrap">
                  <table className="tm-table">
                    <thead>
                      <tr>
                        <th style={{ width: 30 }}>#</th>
                        <th>Actions</th>
                        <th>Task Name</th>
                        <th>Description</th>
                        <th>Task Given To</th>
                        <th>Task Given By</th>
                        <th>Status</th>
                        <th>Blocker</th>
                        <th>Worklog (hrs)</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Priority</th>
                        <th>Total Call</th>
                      </tr>
                    </thead>
                    <tbody>
                      {mainTaskIds.length === 0 ? (
                        <tr>
                          <td colSpan={13} style={{ textAlign: 'center', padding: '40px', color: '#2a7070' }}>
                            No tasks found
                          </td>
                        </tr>
                      ) : (
                        mainTaskIds.map(mid => {
                          const rows = groups[mid]
                          const isCollapsed = collapsed[mid]
                          const openCount = rows.filter(r => r.status === 'Open' || r.status === 'In Progress').length
                          return (
                            <React.Fragment key={mid}>
                              <tr className="tm-group-row" onClick={() => this.toggleGroup(mid)}>
                                <td colSpan={13}>
                                  <span style={{ marginRight: 6 }}>{isCollapsed ? '▶' : '▼'}</span>
                                  <strong>{mid}</strong>
                                  <span style={{ marginLeft: 10, fontWeight: 400, color: '#2a7070', fontSize: 11 }}>
                                    {rows.length} task{rows.length !== 1 ? 's' : ''} &nbsp;·&nbsp; {openCount} open
                                  </span>
                                 </td>
                               </tr>

                              {!isCollapsed && rows.map((t, ri) => (
                                <tr key={t.taskId} className="data-row"
                                  style={{ animationDelay: `${ri * 0.04}s` }}>
                                  <td style={{ textAlign: 'center' }}>{ri + 1}</td>
                                  <td>
                                    <div className="tm-row-actions">
                                      <div
                                        className="tm-row-btn"
                                        title="View Work Logs"
                                        onClick={(e) => {
                                          e.stopPropagation()
                                          this.handleOpenViewTaskWorkLogs(t)
                                        }}
                                      >📋</div>
                                      <div
                                        className="tm-row-btn"
                                        title="Log Work"
                                        onClick={(e) => {
                                          e.stopPropagation()
                                          this.handleOpenCreateWorkLog(t)
                                        }}
                                      >⏱️</div>
                                      <div
                                        className="tm-row-btn"
                                        title="Edit Task"
                                        onClick={(e) => {
                                          e.stopPropagation()
                                          this.handleOpenEditTask(t)
                                        }}
                                      >✏️</div>
                                    </div>
                                  </td>
                                  <td className="tm-cell-task" style={{ maxWidth: 150, whiteSpace: 'normal' }}>
                                    {t.taskName}
                                  </td>
                                  <td style={{ maxWidth: 250, whiteSpace: 'normal', fontSize: 11 }}>
                                    {t.taskDescription || '—'}
                                  </td>
                                  <td>
                                    <span className="tm-employee-chip" title={t.taskGivenToName || t.taskGivenTo}>
                                      {getEmployeeName(t.taskGivenTo, t.taskGivenToName, employees)}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="tm-employee-chip" title={t.taskGivenByName || t.taskGivenBy}>
                                      {getEmployeeName(t.taskGivenBy, t.taskGivenByName, employees)}
                                    </span>
                                  </td>
                                  <td>
                                    <span className={`tm-status ${statusCls(t.status)}`}>
                                      <span className="tm-status-dot" />
                                      {t.status}
                                      {t.isOverdue && <span style={{ marginLeft: 4 }}>⚠️</span>}
                                    </span>
                                  </td>
                                  <td>
                                    {t.anyBlocker ? (
                                      <span className="tm-blocker-badge" title={t.anyBlocker}>
                                        ⚠️
                                      </span>
                                    ) : (
                                      <span style={{ color: '#2a7070' }}>—</span>
                                    )}
                                  </td>
                                  <td className="tm-worklog" style={{ textAlign: 'center' }}>
                                    {t.worklogHour > 0 ? `${t.worklogHour}h` : '—'}
                                  </td>
                                  <td className={`tm-due ${dueClass(t.startDate, t.status)}`}>
                                    {fmtDate(t.startDate)}
                                  </td>
                                  <td className={`tm-due ${dueClass(t.endDate, t.status)}`}>
                                    {fmtDate(t.endDate)}
                                  </td>
                                  <td>
                                    {t.priority && (
                                      <span style={{
                                        fontSize: 10, fontWeight: 700, padding: '2px 7px', borderRadius: 8,
                                        background: t.priority === 'high' ? 'rgba(192,48,48,.12)' : t.priority === 'medium' ? 'rgba(196,128,0,.12)' : 'rgba(0,150,140,.12)',
                                        border: t.priority === 'high' ? '1px solid rgba(192,48,48,.25)' : t.priority === 'medium' ? '1px solid rgba(196,128,0,.25)' : '1px solid rgba(0,150,140,.25)',
                                        color: t.priority === 'high' ? '#7a1010' : t.priority === 'medium' ? '#6a3c00' : '#004a46',
                                        textTransform: 'capitalize'
                                      }}>
                                        {t.priority}
                                      </span>
                                    )}
                                  </td>
                                  <td className="tm-cell-id">{t.totalCall || 0}</td>
                                </tr>
                              ))}
                            </React.Fragment>
                          )
                        })
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="tm-pagination">
                  <div>Showing {filtered.length} of {localTasks.length} tasks</div>
                  <div className="tm-page-btns">
                    {['◀', '1', '2', '3', '4', '▶'].map((p, i) => (
                      <div key={i} className={`tm-page-btn ${p === '1' ? 'active' : ''}`}>{p}</div>
                    ))}
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <span>Rows per page:</span>
                    <select className="tm-input" style={{ width: 56, height: 24, fontSize: 11 }}>
                      {['15', '25', '50', '100'].map(v => <option key={v}>{v}</option>)}
                    </select>
                  </div>
                </div>
              </div>
            )}
          </div>

          <TaskPopup
            isOpen={isTaskPopupOpen}
            onClose={this.handleCloseTaskPopup}
            onSave={this.handleSaveTask}
            onDelete={this.handleDeleteTask}
            task={selectedTask}
            mode={taskPopupMode}
            employees={employees}
            loggedInEmployeeCode={loggedInEmployeeCode}
            isSubmitting={isSubmitting}
            submitError={submitError}
          />

          <WorkLogPopup
            isOpen={isWorkLogPopupOpen}
            onClose={this.handleCloseWorkLogPopup}
            onSave={this.handleSaveWorkLog}
            onDelete={this.handleDeleteWorkLog}
            workLog={selectedWorkLog}
            task={selectedTask}
            mode={workLogPopupMode}
            employees={employees}
            tasks={localTasks}
            loggedInEmployeeCode={loggedInEmployeeCode}
            isSubmitting={isWorkLogSubmitting}
            submitError={workLogSubmitError}
            successMessage={workLogSuccessMessage}
          />
        </div>
      </>
    )
  }
}

const mapStateToProps = (state: any) => ({
  tasks: state.task.tasks || [],
  employees: state.task.employees || [],
  loading: state.task.loading || false,
  error: state.task.error,
  filters: state.task.filters || {}
})

const mapDispatchToProps = {
  getTaskDetails: GetTaskDetails,
  setTaskFilters: SetTaskFilters,
  clearTaskFilters: ClearTaskFilters,
  createTask: CreateTask,
  createWorkLog: CreateWorkLog
}

export default connect(mapStateToProps, mapDispatchToProps)(TaskManagementPage)